import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementPlus from 'element-plus'
import ru from 'element-plus/es/locale/lang/ru'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/api/v1' : `${process.env.VUE_APP_URL || ''}/api/v1`

axios.interceptors.response.use((response) => {
    const newResponse = response
    if (response.request.responseType !== 'blob') {
        newResponse.data = response.data
    }
    return newResponse
}, (error) => {
    // console.log('error', error)
    const newError = error

    if (error.response && error.response.data) {
        if (error.response.data.result) {
            newError.response.data = error.response.data
        }
    }

    return Promise.reject(newError)
})

createApp(App)
    .use(ElementPlus, {
        locale: ru
    })
    .use(router).use(store)
    .mount('#app')
